export default {
  message: String,
  freezeScreen: {
    type: Boolean,
    default: true
  },
  bar: Boolean,
  autoProgress: Boolean,
  scale: {
    type: Number,
    default: 1
  }
}



// WEBPACK FOOTER //
// ./src/components/Loading/_props.js